module.exports = __webpack_public_path__ + "assets/f7b65a2936bf5281accf515b93222f5e.mp3";